import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Store } from '@ngrx/store';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { Observable } from 'rxjs';
import { selectAuthLoading } from '../../store/auth/auth.selectors';
import { ResetPasswordFormComponent } from '../../components/forms';

@Component({
  selector: 'app-reset-password',
  imports: [
    NzSpinModule,
    CommonModule,
    ResetPasswordFormComponent,
  ],
  templateUrl: './reset-password.component.html',
})
export class ResetPasswordComponent {
  loading$: Observable<boolean>;
  currentYear = new Date().getFullYear();

  constructor(private store: Store) {
    this.loading$ = this.store.select(selectAuthLoading);
  }
}
